import { createFileRoute } from '@tanstack/react-router';

type Search = {
  quotes?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/it-partner-quotes')({
  validateSearch: (search: Search): Search => {
    return {
      quotes: search.quotes,
    };
  },
});
